import { useEffect, type ReactNode } from "react";
import { Link } from "react-router-dom";

import { useSignOut } from "../auth/useSignOut";

export function NotFoundScreen(): ReactNode {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-canvas p-8 text-ink">
      <h1 className="text-2xl font-semibold">Not found</h1>
      <p className="text-sm text-muted">
        This page does not exist, or you do not have access to it.
      </p>
      <Link to="/home" className="text-sm text-accent underline">
        Go home
      </Link>
    </div>
  );
}

/** `/logout` signs out and returns to the login screen (note 03 §3.1). */
export function LogoutScreen(): ReactNode {
  const signOut = useSignOut();

  useEffect(() => {
    void signOut();
  }, [signOut]);

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-canvas text-muted"
      role="status"
    >
      Signing out…
    </div>
  );
}
